
<template>
    <div>
      <i
        class="fa fa-info-circle text-primary"
        style="cursor: pointer"
        @click="showModal"
      ></i>
  
      <div
        class="modal fade"
        :id="'descriptionModal-' + index"
        tabindex="-1"
        role="dialog"
        aria-labelledby="descriptionModalLabel"
        aria-hidden="true"
      >
      <div class="modal-dialog modal-xl d-flex justify-content-center">
           <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="descriptionModalLabel">
                {{ $t("label.description") }}
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-lg">
              {{ description }}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                {{ $t("btn.close") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import $ from "jquery";
  
  export default Vue.extend({
    props: {
      row: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
      datatable: {
        type: Object,
        required: true,
      },
    },
    computed: {
      description() {
        return this.row.description;
      },
    },
    methods: {
      showModal() {
        // Trigger the modal to show
        const modalElement = document.getElementById(`descriptionModal-${this.index}`);
        if (modalElement) {
          $(modalElement).modal("show");
        }
      },
    },
  });
  </script>
  
  <style scoped>
  </style>